/**
 * This file is auto-generated from Gender.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const MALE = lang => {
    switch (lang) {
        case 'pl':
            return 'Mężczyzna';
        case 'en':
            return 'Male';
    }
};
export const FEMALE = lang => {
    switch (lang) {
        case 'pl':
            return 'Kobieta';
        case 'en':
            return 'Female';
    }
};
export const OTHER = lang => {
    switch (lang) {
        case 'pl':
            return 'Inna';
        case 'en':
            return 'Other';
    }
};
//# sourceMappingURL=Gender.loc.js.map